import request from "../request";
import Url from "../url/report";

const getLogPower = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getLogPower + path,
    ...restParams,
  });
};
const getPowerOverview = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getPowerOverview + path,
    ...restParams,
  });
};
const getMonthlyYearComparison = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getMonthlyYearComparison + path,
    ...restParams,
  });
};
const getEnergyShare = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getEnergyShare + path,
    ...restParams,
  });
};
const getMonthlyEnergyList = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getMonthlyEnergyList + path,
    ...restParams,
  });
};
const getEnergyTrend = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getEnergyTrend + path,
    ...restParams,
  });
};
const getHemsOverview = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getHemsOverview + path,
    ...restParams,
  });
};
const getFloorPeriodComparison = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getFloorPeriodComparison + path,
    ...restParams,
  });
};
const getMonthlyGrowthStatistics = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getMonthlyGrowthStatistics + path,
    ...restParams,
  });
};
const getOptimalContractCapacity = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getOptimalContractCapacity + path,
    ...restParams,
  });
};
const getMultiPeriodComparison = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getMultiPeriodComparison + path,
    ...restParams,
  });
};
const getFloorDailyComparison = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getFloorDailyComparison + path,
    ...restParams,
  });
};
const getGreenEnergyDashboard = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getGreenEnergyDashboard + path,
    ...restParams,
  });
};
const getAreaPerformance = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getAreaPerformance + path,
    ...restParams,
  });
};

const getDemandManagement = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getDemandManagement + path,
    ...restParams,
  });
};

const getTimeOfUseStatistics = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getTimeOfUseStatistics + path,
    ...restParams,
  });
};

const getFloorMonthlyComparison = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getFloorMonthlyComparison + path,
    ...restParams,
  });
};
const getLogPowerElectricityPrices = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getLogPowerElectricityPrices + path,
    ...restParams,
  });
};
const getPublicLogPower = ({ path = "", ...restParams } = {}) => {
  return request.post({
    url: Url.getPublicLogPower + path,
    ...restParams,
  });
};
const getBuildingList = ({ path = "", ...restParams } = {}) => {
  return request.get({
    url: Url.getBuildingList + path,
    ...restParams,
  });
};
const getEnergyList = ({ path = "", ...restParams } = {}) => {
  return request.get({
    url: Url.getEnergyList + path,
    ...restParams,
  });
};

export default {
  getLogPower,
  getPowerOverview,
  getMonthlyYearComparison,
  getEnergyShare,
  getMonthlyEnergyList,
  getEnergyTrend,
  getHemsOverview,
  getFloorPeriodComparison,
  getMonthlyGrowthStatistics,
  getOptimalContractCapacity,
  getMultiPeriodComparison,
  getFloorDailyComparison,
  getGreenEnergyDashboard,
  getAreaPerformance,
  getDemandManagement,
  getTimeOfUseStatistics,
  getFloorMonthlyComparison,
  getLogPowerElectricityPrices,
  getPublicLogPower,
  getBuildingList,
  getEnergyList,
};
